/**
 * Runtime-platform detection for wagepro-web.
 *
 * The SAME `dist/` bundle this app builds is served two ways: standalone in a
 * browser, and wrapped by `apps/wagepro-mobile`'s Capacitor shell (CLAUDE.md
 * § "Mobile App Architecture" — the shell has no source of its own, it points
 * `webDir` at `../wagepro-web/dist`). Anything that must differ between those
 * two runtimes branches on these helpers, never on a build flag: one bundle,
 * two runtimes, resolved at load time.
 *
 * `@capacitor/core`'s `Capacitor` object is safe to import in a plain browser
 * — off-device `isNativePlatform()` simply returns `false` and
 * `getPlatform()` returns `'web'`, so no `Capacitor.isNativePlatform()` call
 * site needs its own guard. Mirrors `apps/mileagepro-web/src/lib/platform.ts`,
 * the reference implementation named in ADR-019.
 */
import { Capacitor } from '@capacitor/core';

/** Running inside a native Capacitor shell (Android or iOS), not a browser. */
export const isNative = (): boolean => Capacitor.isNativePlatform();

/** Running as a plain web app in a browser. */
export const isWeb = (): boolean => !Capacitor.isNativePlatform();

/** Running inside the Android Capacitor shell specifically. */
export const isAndroid = (): boolean => Capacitor.getPlatform() === 'android';

/** Running inside the iOS Capacitor shell specifically. */
export const isIOS = (): boolean => Capacitor.getPlatform() === 'ios';
